import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Chain notification sound player
// ---------------------------------------------------------------------------
// Jamaica-time display standard (2026-04-20) — DISPLAY-ONLY.
// Every Date.prototype.toLocale* call now defaults timeZone to America/Jamaica
// when the caller did NOT specify one. Backend/DB still store UTC. Calls that
// explicitly set timeZone are untouched.
// ---------------------------------------------------------------------------
(function () {
  const JM = { timeZone: "America/Jamaica" };
  const withJM = (opts) => {
    if (!opts || typeof opts !== "object") return JM;
    if (Object.prototype.hasOwnProperty.call(opts, "timeZone")) return opts;
    return Object.assign({}, opts, JM);
  };
  const _tls = Date.prototype.toLocaleString;
  const _tld = Date.prototype.toLocaleDateString;
  const _tlt = Date.prototype.toLocaleTimeString;
  Date.prototype.toLocaleString     = function (locales, options) { return _tls.call(this, locales || "en-JM", withJM(options)); };
  Date.prototype.toLocaleDateString = function (locales, options) { return _tld.call(this, locales || "en-JM", withJM(options)); };
  Date.prototype.toLocaleTimeString = function (locales, options) { return _tlt.call(this, locales || "en-JM", withJM(options)); };
})();


const chainSound = new Audio('/sounds/chain.mp3');
chainSound.volume = 0.7;

function playChainSound() {
  chainSound.currentTime = 0;
  chainSound.play().catch(e => console.log('Sound play failed:', e));
}

// Register Service Worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SW registered:', registration.scope);
      })
      .catch((error) => {
        console.log('SW registration failed:', error);
      });
    
    // Listen for messages from service worker to play sound
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data && event.data.type === 'PLAY_CHAIN_SOUND') {
        playChainSound();
      }
    });
  });
}

// Also expose sound player globally for direct use
window.playChainSound = playChainSound;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
